<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onCloseConfirm(() => (open = false))"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="模块名称" prop="moduleName">
        <a-input v-model="form.moduleName" placeholder="请输入模块名称" :maxLength="50" allow-clear />
      </a-form-model-item>
      <a-form-model-item v-if="!isEdit" label="模块类型" prop="moduleSystemType">
        <a-radio-group v-model="form.moduleSystemType" button-style="solid">
          <a-radio-button :value="0">平台模块</a-radio-button>
          <a-radio-button :value="1">系统内置</a-radio-button>
          <a-radio-button :value="2">其它模块</a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="模块描述" prop="description">
        <a-textarea v-model="form.description" placeholder="请输入模块描述" :rows="4" :maxLength="500" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-textarea v-model="form.remark" placeholder="请输入备注（选填）" :rows="3" :maxLength="255" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addModule, editModule, getModuleDetail } from '@/api/system/module'

export default {
  name: 'CreateForm',
  data() {
    return {
      submitLoading: false,
      formTitle: '新增功能模块',
      open: false,
      showLoading: false,
      isEdit: false,
      form: {
        id: undefined,
        moduleName: '',
        moduleSystemType: 0,
        parentId: 0,
        description: '',
        remark: ''
      },
      rules: {
        moduleName: [{ required: true, message: '模块名称不能为空', trigger: 'blur' }],
        moduleSystemType: [
          {
            validator: (rule, value, callback) => {
              if (!this.isEdit && (value === undefined || value === null)) {
                callback(new Error('请选择模块类型'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        description: [{ required: true, message: '模块描述不能为空', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onCloseConfirm(callback) {
      const that = this
      this.$confirm({
        title: '是否确认关闭？未保存的数据将丢失',
        onOk() {
          callback && callback()
          that.reset()
        },
        onCancel() {}
      })
    },
    cancel() {
      this.onCloseConfirm(() => {
        this.open = false
      })
    },
    reset() {
      this.form = {
        id: undefined,
        moduleName: '',
        moduleSystemType: 0,
        parentId: 0,
        description: '',
        remark: ''
      }
      this.isEdit = false
      this.$refs.form && this.$refs.form.clearValidate()
    },
    init(record) {
      this.reset()
      if (record && record.id) {
        this.isEdit = true
        this.formTitle = '编辑功能模块'
        getModuleDetail(record.id)
          .then((res) => {
            if (res && res.data) {
              this.form = {
                id: res.data.id,
                moduleName: res.data.moduleName || '',
                parentId: res.data.parentId || 0,
                description: res.data.description || '',
                remark: res.data.remark || ''
              }
            }
            this.open = true
          })
          .catch(() => {
            this.$message.error('获取功能模块详情失败')
          })
      } else {
        this.isEdit = false
        this.formTitle = '新增功能模块'
        this.open = true
      }
    },
    submitForm() {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true

          let submitData
          if (this.isEdit) {
            submitData = {
              id: this.form.id,
              moduleName: this.form.moduleName,
              parentId: this.form.parentId,
              description: this.form.description,
              remark: this.form.remark || ''
            }
          } else {
            submitData = {
              moduleName: this.form.moduleName,
              moduleSystemType: this.form.moduleSystemType,
              parentId: this.form.parentId,
              description: this.form.description,
              remark: this.form.remark || ''
            }
          }

          const apiCall = this.isEdit ? editModule(submitData) : addModule(submitData)
          apiCall
            .then(() => {
              this.$message.success(this.isEdit ? '编辑功能模块成功' : '新增功能模块成功', 3)
              this.open = false
              this.$emit('ok')
            })
            .catch(() => {
              this.$message.error(this.isEdit ? '编辑功能模块失败' : '新增功能模块失败')
            })
            .finally(() => {
              this.submitLoading = false
              this.showLoading = false
            })
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop && this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.bottom-control {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}
</style>

